import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Translation from "../../shared/Translation";
import Tabs from '@showclix-shared/Tabs';

const lgBreakpoint = 960;

const TABS_LABELS = {
    tickets: <Translation>{'checkout__tickets'}</Translation>,
    eventInfo: <Translation>{'checkout__event_info'}</Translation>,
};

export const DynamicPageContent = (props) => {
    const { venues } = useSelector((state) => state?.venue);

    const [windowWidth, setWindowWidth] = useState(0);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        }

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    if (windowWidth >= lgBreakpoint) {
        return props.children.filter(child => child?.props?.tab2);
    }

    return (
        <div className='dynamic-page-content'>
            <Tabs openToTab={TABS_LABELS.tickets}>
                <div label={TABS_LABELS.tickets} title={<Translation>{'checkout__tickets'}</Translation>} active>{props.children?.filter(child => child?.props?.tab1)}</div>
                <div label={TABS_LABELS.eventInfo} title={<Translation>{'checkout__event_info'}</Translation>}>{props.children?.filter(child => child?.props?.tab2)}</div>
            </Tabs>
        </div>
    )
};
